import React from 'react';
import HeaderStarpath from "../../components/header/HeaderStarpath";
import Breadcrumb from "../../components/header/breadcrumb";
import FooterStarpath from "../../components/footer/FooterStarpath";
import CaptainList from "./CaptainList";

function CaptainsPage() {
    return (
        <>
            <HeaderStarpath/>
            <main>
                <Breadcrumb title={"Your Captains"} breadcrumbs={[{name: "Captains", "link": "/profile/captains"}]}/>
                <div className="community-area primary-bg pt-120 pb-175">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="community-wrap">
                                    <CaptainList />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <FooterStarpath/>
        </>
    )
}

export default CaptainsPage
